import React, {Component} from 'react';
import {Button, Container, Divider, Form, Header, Input, Message, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Footer from "./footer";
import {resolveErrorMessage} from "../utils/common";
import {CustomGrid} from './custom-common';
import {ResetPasswordRequest} from "../services/types";
import {resetPassword} from "../services/services";

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            passwordError: null,
            requesting: false,
            submitError: null
        };
    }

    componentDidMount() {
        window.onbeforeunload = null;
    }

    handleChange = (e, {name, value}) => this.setState({[name]: value, error: ''})

    getRouteBase = () => {
        return window.location.pathname.startsWith('/enrollment') ? '/enrollment' : '';
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const errors = this.validate();
        if (errors) {
            return
        }
        this.setState({requesting: true, submitError: null});
        try {
            const token = new URLSearchParams(window.location.search).get("token");
            const resetPasswordToken = new URLSearchParams(window.location.search).get("resetPasswordToken");
            const payload = new ResetPasswordRequest({
                token,
                resetPasswordToken,
                password: this.state.password
            });
            const response = await resetPassword(payload)
            if (response.status === 200) {
                const newToken = response.newToken;
                this.setState({requesting: false, submitError: null});
                window.location.replace(this.getRouteBase() +`/?token=${newToken}`);
            } else {
                throw(new Error("Http status not OK " + response.statusText));
            }
        } catch (e) {
            const error = resolveErrorMessage(e, "Invalid token")
            if (error === "Invalid token") {
                this.props.history.replace({pathname: "/forgotPassword", state: {resetLink: true}});
            }

            this.setState({
                requesting: false,
                submitError: error
            });
        }
    }

    validate = () => {
        let isError = false;
        const {password} = this.state;
        const invalidPassword = (password.length < 10 || password.search(/[A-Z]/) < 0) || password.match(/\d+/g) < 1;
        if (invalidPassword) {
            isError = true;
            this.setState({
                passwordError: "Passwords must contain at least 10 characters, one uppercase letter, and one number.",
                success: false
            })
        }
        return isError;
    }

    render() {
        const {password, passwordError, confirmPassword, requesting, submitError} = this.state;
        const token = new URLSearchParams(window.location.search).get("token");
        return (
            <React.Fragment>
                <div>
                    {token ? (

                        <CustomGrid container stackable columns={1} centered style={{marginTop: 0}} fitted={'horizontally'}>
                            <CustomGrid.Column>
                                <CustomGrid centered>
                                    <CustomGrid.Column style={{marginTop: '3em'}} width={5}>
                                        <Divider hidden/>
                                        <Header as={"h2"} textAlign={"center"}>Reset password</Header>
                                        <Segment padded>
                                            <p className={"small"}>
                                                Passwords must contain at least 10 characters, one uppercase letter, and one number.
                                            </p>
                                            <Form>
                                                <Form.Field error={!!passwordError} required>
                                                    <label>Enter password</label>
                                                    <Input
                                                        fluid type="password"
                                                        name='password'
                                                        value={password}
                                                        onChange={this.handleChange}
                                                        onFocus={() => {
                                                            this.setState({passwordError: null});
                                                        }}
                                                        onBlur={(e) => {
                                                            const val = e.target.value;
                                                            this.validate(val);
                                                        }}
                                                    />
                                                    {!!passwordError &&
                                                    <span className={"errorText smaller"}>{passwordError}</span>}
                                                </Form.Field>

                                                <Form.Input fluid type="password" label='Re-enter password'
                                                            name='confirmPassword' required
                                                            value={confirmPassword} onChange={this.handleChange}/>
                                                {!!submitError &&
                                                <Form.Field><Message negative>{submitError}</Message></Form.Field>}

                                                <Form.Field>
                                                    <Button
                                                        onClick={this.handleSubmit}
                                                        primary
                                                        disabled={password.length < 10 || !!passwordError || confirmPassword !== password || requesting}
                                                        loading={requesting}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Field>
                                            </Form>
                                        </Segment>
                                    </CustomGrid.Column>
                                </CustomGrid>
                            </CustomGrid.Column>
                        </CustomGrid>
                    ) : (
                        <Container>
                            <Divider hidden/>
                            <Message negative>Missing token</Message>
                        </Container>
                    )}
                </div>
                <Footer/>
            </React.Fragment>
        )
    }
}

export default withRouter(connect()(ResetPassword));